var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 12C38.0589 12 30 20.0589 30 30C30 39.9411 38.0589 48 48 48C57.9411 48 66 39.9411 66 30C66 20.0589 57.9411 12 48 12ZM22 30C22 15.6406 33.6406 4 48 4C62.3594 4 74 15.6406 74 30C74 44.3594 62.3594 56 48 56C33.6406 56 22 44.3594 22 30Z",
    fill: "#46A348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 56C30.5401 56 16.3653 66.9696 12.8528 81.0458C12.675 81.758 12.853 82.3781 13.3622 82.9278C13.9197 83.5296 14.8689 84 16 84H80C81.1311 84 82.0803 83.5296 82.6378 82.9278C83.147 82.3781 83.3249 81.758 83.1472 81.0458C79.6347 66.9696 65.4599 56 48 56ZM5.09078 79.1089C9.59871 61.0436 27.326 48 48 48C68.674 48 86.4013 61.0436 90.9092 79.1089C92.7792 86.6027 86.2682 92 80 92H16C9.73174 92 3.2208 86.6027 5.09078 79.1089Z",
    fill: "#46A348"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8d0ff04c45aba5418e153d2c5f5064a5.svg";
export { ForwardRef as ReactComponent };